import { OrderCustomerState } from "@/models/Orders/OrderEnums";

export function orderCustomerStateToColor(orderState: OrderCustomerState) {
  switch (orderState) {
    case OrderCustomerState.Concept:
      return "secondary lighten-2";
    case OrderCustomerState.InProgress:
      return "accent";
    case OrderCustomerState.Cancelled:
      return "error";
    case OrderCustomerState.Confirmed:
      return "primary";
    case OrderCustomerState.NotFilled:
      return "warning";
    case OrderCustomerState.Sent:
      return "secondary";

    default:
      return "secondary";
  }
}
